import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-5" data-id="element-89">
      <button className="flex justify-between items-center w-full text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-90">
        <h3 className="text-lg font-semibold text-gray-900 pr-8" data-id="element-91">{question}</h3>
        {isOpen ? <ChevronUpIcon size={20} className="text-orange-500 shrink-0" data-id="element-92" /> : <ChevronDownIcon size={20} className="text-gray-400 shrink-0" data-id="element-93" />}
      </button>
      {isOpen && <div className="mt-3 text-gray-600 leading-relaxed" data-id="element-94">
          {'Yes. FluidForm integrates with your existing stack. Custom integrations are available in the Enterprise plan (coming soon to Pro).'}
        </div>}
    </div>;
};
const defaultFaqs = [{
  question: 'What is FluidForm?',
  answer: 'FluidForm is an AI-native form engine that captures structured data from natural inputs — text, voice, documents, and photos — and outputs schema-aligned submissions.'
}, {
  question: 'How is this different from a chatbot?',
  answer: "Chat UIs can talk, but they're unreliable at producing complete, schema-valid submissions. FluidForm is schema-first: conversation is used to complete and validate a form — then you get clean structured output."
}, {
  question: 'How reliable is the AI?',
  answer: 'FluidForm is designed for reliability through schema constraints, validation, and confirmations. You control when AI can auto-fill vs. when it must ask or confirm.'
}, {
  question: 'Can I customize the look and feel?',
  answer: 'Yes. Use styling controls or custom CSS. Keep full branding and UX control.'
}, {
  question: 'Is FluidForm suitable for regulated industries like fintech, insurance, and real estate?',
  answer: "Yes. FluidForm is built schema-first — every submission is validated, structured, and audit-ready. It's designed for workflows where data accuracy and compliance matter."
}, {
  question: 'How does FluidForm handle sensitive documents like IDs and financial statements?',
  answer: 'FluidForm extracts and validates document data without storing sensitive files beyond what your configuration allows. You control what gets captured, validated, and passed to your systems.'
}, {
  question: 'Can FluidForm integrate with our existing onboarding or CRM tools?',
  answer: 'Yes. FluidForm outputs clean, schema-aligned JSON that connects to your existing stack. Custom integrations are available on Pro and Enterprise plans.'
}];
const FAQ = ({
  faqs
}: {
  faqs?: {
    question: string;
    answer: string;
  }[];
}) => {
  const items = faqs || defaultFaqs;
  return <section className="w-full bg-gray-50 py-[5.75rem]" id="faq" data-id="element-95">
      <div className="container mx-auto px-4" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-98">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-99">
          {items.map((faq, index) => <FAQItem key={index} {...faq} data-id="element-100" />)}
        </div>
      </div>
    </section>;
};
export default FAQ;